import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { OrderStageCard } from "@/components/admin/OrderStageCard";

export default function OrderManage({ order, open, onOpenChange, onUpdated }) {
  const [stages, setStages] = useState([]);
  const [current, setCurrent] = useState(order);

  useEffect(() => { setCurrent(order); }, [order]);

  useEffect(() => {
    if (!open) return;
    api.get("/admin/wa-order-stages").then((r) => setStages(r.data)).catch(() => setStages([]));
  }, [open]);

  const refreshOrder = async () => {
    try {
      const { data } = await api.get(`/admin/orders`);
      const updated = data.find((o) => o.id === current.id);
      if (updated) {
        setCurrent(updated);
        onUpdated?.(updated);
      }
    } catch (e) {
      console.error("Failed to refresh order after update:", e);
    }
  };

  if (!current) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="order-manage-dialog" className="max-w-4xl max-h-[92vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 flex-wrap">
            <span>Order</span>
            <span className="font-mono text-sm text-zinc-500">{current.id}</span>
            <span className="text-zinc-400">·</span>
            <span className="text-brand">{current.shipping?.name || current.user_email}</span>
          </DialogTitle>
          <div className="text-xs text-zinc-500 mt-1">
            {(current.items || []).reduce((s, i) => s + i.quantity, 0)} items · {current.shipping?.phone || "no phone"}
          </div>
        </DialogHeader>

        <div className="mt-4">
          <div className="text-xs font-bold uppercase tracking-[0.15em] text-zinc-500 mb-3">Send stage-by-stage WhatsApp updates</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {stages.map((s) => (
              <OrderStageCard
                key={s.key}
                stage={s}
                order={current}
                onLogged={refreshOrder}
                onOrderSaved={(u) => { setCurrent(u); onUpdated?.(u); }}
              />
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
